import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Mail(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M34 7.92v1.71l-15.021 8.901a1.92 1.92 0 01-1.958 0L2 9.63V7.92C2 6.86 2.86 6 3.92 6h28.16C33.14 6 34 6.86 34 7.92zM18 20.08a3.185 3.185 0 01-1.631-.449L2 11.117V28.4c0 1.06.86 1.92 1.92 1.92h28.16c1.06 0 1.92-.86 1.92-1.92V11.117L19.631 19.63a3.185 3.185 0 01-1.631.449z"></path>
    </IconSvg>
  );
}
